/* -----------------------------------------------------------------------------
 * User SM Mutations
 *
 * @description - Mutations of User SM. Check ./README.md for more info.
 * -----------------------------------------------------------------------------
 */

import Vue from 'vue'

export default {

  /**
   * Set user data field
   */
  SET_USER_DATA_FIELD (state, { f, v }) {
    state.user[f] = v
  },

  // -------------------------------------------------------------------- [POLL]

  /**
   * Set poll prototype
   */
  SET_POLL_PROTOTYPE (state, prototype) {
    state.poll.prototype = prototype
  },

  /**
   * Set poll defaults
   */
  SET_POLL_DEFAULTS (state, length) {
    state.poll.answers = [...new Array(length).fill(null)]
  },

  /**
   * Set poll answer
   */
  SET_POLL_ANSWER (state, { idx, v }) {
    Vue.set(state.poll.answers, idx, v)
  },

  // --------------------------------------------------------------- [PORTFOLIO]

  /**
   * Set portfolio field
   */
  SET_PORTFOLIO_FIELD (state, { f, v }) {
    state.portfolio[f] = v
  },

  /**
   * Set risk profiles
   */
  SET_RISK_PROFILES (state, profiles) {
    state.portfolio.riskProfiles = profiles
  },

  /**
   * Set sms field
   */
  SET_SMS_FIELD (state, { f, v }) {
    state.sms[f] = v
  },

  /**
   * Set terms
   */
  SET_TERMS (state, termsData) {
    state.terms = termsData
  },

  /**
   * Set tracking
   */
  SET_TRACKING (state, v) {
    state.tracking = v
  }

}
